import { BugFlowAnimation } from "@/components/BugFlowAnimation";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const AnimationDemo = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 sm:p-8">
      <ThemeToggle />
      <Link to="/" className="absolute top-4 left-4 flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
        <ArrowLeft className="w-4 h-4" /> Back
      </Link>
      <h1 className="font-heading text-2xl sm:text-4xl font-bold mb-2 text-foreground text-center">
        Bug Flow <span className="text-accent">Animation</span>
      </h1>
      <p className="text-muted-foreground text-sm mb-8 text-center">Bugs flow in → Healion fixes → PRs come out</p>
      <BugFlowAnimation />
    </div>
  );
};

export default AnimationDemo;
